import { render, staticRenderFns } from "./LiHanProduct.vue?vue&type=template&id=58054f67&scoped=true"
import script from "./LiHanProduct.vue?vue&type=script&lang=js"
export * from "./LiHanProduct.vue?vue&type=script&lang=js"
import style0 from "./LiHanProduct.vue?vue&type=style&index=0&id=58054f67&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58054f67",
  null
  
)

export default component.exports